import client from "../apollo/apolloClient";
import ApolloChannels from "../apollo/apolloChannels";
import API from "../axios";
import axios from "axios";

import { apiError } from "../observability/apiError";

export const getChannels = async (companyId) => {
  try {
    const variables = { companyId };
    const { data } = await client.query({
      query: ApolloChannels.GET_ALL_CHANNELS,
      variables,
    });
    return data.channels;
  } catch (error) {
    return error;
  }
};

export const getWhatsappActiveChannels = async (companyId) => {
  try {
    const variables = { companyId };
    const { data } = await client.query({
      query: ApolloChannels.GET_WHATSAPP_ACTIVE_CHANNELS,
      variables,
    });
    return data.channels;
  } catch (error) {
    return error;
  }
};

export const useChatBot = async (channelId, active) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloChannels.UPDATE_CHANNEL_CHAT_BOT,
      variables: { id: channelId, active },
    });
    return data;
  } catch (error) {
    throw apiError("ERROR_UPDATING_CHATBOT_STATUS", error, {
      operation: "useChatBot",
      module: "utils/channels",
    });
  }
};

export const getFacebookChannels = async (channels) => {
  try {
    const facebookPages = channels?.filter(
      (channel) => channel.platform.name === "MESSENGER"
    );
    if (facebookPages) {
      const facebookChannels = facebookPages?.map(async (channel) => {
        try {
          const url = `https://graph.facebook.com/v21.0/${channel.pageId}/picture?redirect=0`;
          const data = {
            access_token: channel.pageToken,
          };
          const imageUrl = await axios.get(url, data);
          return {
            id: channel.id,
            pageId: channel.pageId,
            title: channel.name,
            date: channel.date ? channel.date : "",
            image: imageUrl?.data?.data?.url || '',
            isActive: channel.isActive,
            pageToken: channel.pageToken,
            updatedAt: channel.updatedAt ? channel.updatedAt : "",
            status: channel.status,
            useChatbot: channel.useChatbot,
          };
        } catch (error) {
          console.error(error);
        }
      });
      const facebookChannelsReturned = await Promise.all(facebookChannels);
      return facebookChannelsReturned;
    }
    return [];
  } catch (error) {
    throw error;
  }
};

export const getWhatsappChannels = (channels) => {
  const whatsappNumbers = channels?.filter(
    (channel) => channel.platform.name === "WHATSAPP"
  );
  if (whatsappNumbers) {
    const whatsappChannels = whatsappNumbers?.map((channel) => ({
      id: channel.id,
      pageId: channel.pageId,
      title: channel.name,
      date: channel.date ? channel.date : "",
      isActive: channel.isActive,
      pageToken: channel.pageToken,
      updatedAt: channel.updatedAt ? channel.updatedAt : "",
      status: channel.status,
      useChatbot: channel.useChatbot,
      platform: channel.platform,
      phone: channel.phone,
      qualityRating: channel.qualityRating,
      currentLimit: channel.currentLimit,
      providerId: channel.providerId,

    }));
    return whatsappChannels;
  }
  return [];
};

export const getChannelQr = async (channelId, slotName) => {
  try {
    const QR = await API.post("/getQR", { channelId, slotName });
    return QR.data.qrUrl;
  } catch (error) {
    throw error;
  }
};

export const getChannelStatus = async (getChatHistory, chatHistoryTime) => {
  try {
    const response = await API.post("/getChannelStatus", {
      getChatHistory,
      chatHistoryTime,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutWhatsappSlot = async (channelId) => {
  try {
    const response = await API.post("/logoutSlot", { channelId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const facebookCallback = async (response) => {
  try {
    if (response.code) {
      // New flow: config_id + code → System User token (never expires)
      const result = await API.post("/fbUserPermanentToken", { code: response.code });
      return result.data;
    }
    // Legacy fallback: scope-based → accessToken + userID (LinkChannelsWidget)
    const { userID, accessToken } = response;
    const result = await API.post("/fbUserPermanentToken", { accessToken, userID });
    return result.data;
  } catch (error) {
    console.error('Error linking Facebook pages:', error);
    return { error: error.message };
  }
};

export const updateStatusChannel = async (status, channelId) => {
  try {
    await client.mutate({
      mutation: ApolloChannels.UPDATE_CHANNEL_STATUS,
      variables: { id: channelId, active: status },
    });
    return true;
  } catch (error) {
    return { error };
  }
};

export const editChannelName = async (channelId, newSlotName) => {
  const updatedChannel = await client.mutate({
    mutation: ApolloChannels.UPDATE_CHANNEL_NAME,
    variables: { id: channelId, name: newSlotName },
  });
  if (updatedChannel?.data?.updateChannel?.id)
    return updatedChannel.data.updateChannel.id;
  throw new Error("Error updating channel name");
};
